import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_forex_data_source_history_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  data_source_hdr_guid: fromDatatype.GuidDataFieldInterface;
  date_txn: fromDatatype.TimestampTzDatatypeInterface;
  open: fromDatatype.NumericDatatypeInterface;
  high: fromDatatype.NumericDatatypeInterface;
  low: fromDatatype.NumericDatatypeInterface;
  close: fromDatatype.NumericDatatypeInterface;
  period: fromDatatype.NumericDatatypeInterface;
  sell_rate: fromDatatype.NumericDatatypeInterface;
  buy_rate: fromDatatype.NumericDatatypeInterface;
  mid_rate: fromDatatype.NumericDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
}

export class bl_fi_forex_data_source_history_RowClass implements bl_fi_forex_data_source_history_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  data_source_hdr_guid: fromDatatype.GuidDataFieldInterface;
  date_txn: fromDatatype.TimestampTzDatatypeInterface;
  open: fromDatatype.NumericDatatypeInterface;
  high: fromDatatype.NumericDatatypeInterface;
  low: fromDatatype.NumericDatatypeInterface;
  close: fromDatatype.NumericDatatypeInterface;
  period: fromDatatype.NumericDatatypeInterface;
  sell_rate: fromDatatype.NumericDatatypeInterface;
  buy_rate: fromDatatype.NumericDatatypeInterface;
  mid_rate: fromDatatype.NumericDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
}